/* eslint-disable */
<template>
  <div id="app">
    <TopNav />
    <Navbar />
    <router-view />
    <Footer />
  </div>
</template>

<script>
import "./assets/css/style.css";
import TopNav from "./components/TopNav";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default {
  name: "App",
  components: {
    TopNav,
    Navbar,
    Footer
  },
  methods: {
    // GET CART ITEMS FROM LOCAL STORAGE
    getCartItem: function() {
      let cart;
      // CHECK IF THERE'S CART ITEM
      if (sessionStorage.getItem("cart") === null) {
        cart = [];
      } else {
        cart = JSON.parse(sessionStorage.getItem("cart"));
      }

      this.updateCart(cart);
      this.getAllProduct();
    },
    updateCart: function(cart) {
      // PUSH ITEM TO CART
      this.$store.state.cart = cart;
    },
    getAllProduct: function() {
      // GET ALL PRODUCTS WHEN COMPONENT LOADS
      this.$store.dispatch("getAllProducts");
    }
  },
  mounted() {
    this.getCartItem();
  },
  watch: {
    // WATCH WHEN ROUTES CHANGES
    $route: {
      handler: to => {
        document.title = to.meta.title || "MB Clothing Ecommerce website";
      },
      immediate: true
    }
  }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25 ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>